import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import { CreateButton } from 'react-admin';
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  SimpleForm,
  TextInput,
  EditButton,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  AutocompleteInput,
  DateInput,
  Filter,
  BooleanInput,
  SelectInput,
  required
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Тэтгэлэгийн нэр" source="name" alwaysOn />
  </Filter>
);

const Action = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    basePath,
  } = props

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const ScholarshipList = (props) => (
  <List {...props} filters={<TextFilter/>} actions={<Action props={props} />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField label="Тэтгэлэгийн нэр" source="name" />
      <TextField label="Боловсролын зэрэг" source="degree" />
      <TextField source="tags" />
      <EditButton />
    </Datagrid>
  </List>
);

export const ScholarshipEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <BooleanInput label="Notification явуулах уу?" source="shouldSendNotification" initialValue={false} />
      <TextInput disabled source="id" />
      <TextInput fullWidth multiline source="picture" />
      <TextInput multiline fullWidth rows={3} source="name" />
      <ReferenceInput label="Service provider" source="providerId" reference="contentProviders" perPage={100}>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="degree" />
      <ReferenceInput label="Хэл (tag)" source="tagging.languageId" reference="languages" validate={[required()]}>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceArrayInput source="tagging.countryIds" label="Харгалзах улсууд (tag)" validate={[required()]} reference="countries">
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
      <ReferenceArrayInput label="Tag" source="tags" reference="tags" perPage={500}>
        <SelectArrayInput optionText="name" optionValue="name" />
      </ReferenceArrayInput>
      <RichTextInput source="coverage" toolbar={[ ['bold', 'italic', 'underline', 'link'], [{'list': 'bullet'}] ]}  />
      <RichTextInput source="description" toolbar={[ ['bold', 'italic', 'underline', 'link'], [{'list': 'bullet'}] ]} />
      <RichTextInput source="requirement" toolbar={[ ['bold', 'italic', 'underline', 'link'], [{'list': 'bullet'}] ]} />
      <DateInput source="deadline" />
      <TextInput fullWidth source="link" />
    </SimpleForm>
  </Edit>
);

export const ScholarshipCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <BooleanInput label="Notification явуулах уу?" source="shouldSendNotification" initialValue={true} />
      <TextInput disabled source="id" />
      <TextInput fullWidth multiline source="picture" />
      <TextInput multiline fullWidth rows={3} source="name" />
      <ReferenceInput label="Service provider" source="providerId" reference="contentProviders" perPage={100}>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="degree" />
      <ReferenceInput label="Хэл (tag)" source="tagging.languageId" reference="languages" validate={[required()]}>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceArrayInput source="tagging.countryIds" label="Харгалзах улсууд (tag)" validate={[required()]} reference="countries">
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
      <ReferenceArrayInput label="Tag" source="tags" reference="tags" perPage={500}>
        <SelectArrayInput optionText="name" optionValue="name" />
      </ReferenceArrayInput>
      <RichTextInput source="coverage" toolbar={[ ['bold', 'italic', 'underline', 'link'], [{'list': 'bullet'}] ]} />
      <RichTextInput source="description" toolbar={[ ['bold', 'italic', 'underline', 'link'], [{'list': 'bullet'}] ]} />
      <RichTextInput source="requirement" toolbar={[ ['bold', 'italic', 'underline', 'link'], [{'list': 'bullet'}] ]} />
      <DateInput source="deadline" />
      <TextInput fullWidth source="link" />
    </SimpleForm>
  </Create>
);
